// extracted by mini-css-extract-plugin
module.exports = {"rightPostal":"ContactPage_rightPostal__RHZn5","form-control-width-40":"ContactPage_form-control-width-40__0P7IW","inputFontSize":"ContactPage_inputFontSize__08nDa"};